import React from 'react';
import PropTypes from 'prop-types';

const SwitchButton = props => {
  const id = props.id.length > 0 ? props.id : props.name;

  const onSwitch = e => {
    props.onChange(id, props.checked);
    e.preventDefault();
  };

  return (
    <div className="tvt-boolean-toggle-switch">
      <label id={id} onClick={onSwitch} className="switch">
        <input
          id={id}
          name={props.name}
          type="checkbox"
          value="1"
          onChange={e => {
            console.log(e);
            props.onChange(id, props.checked);
            return null;
          }}
          checked={props.checked === 'OR'}
          disabled={props.disabled}
        />
        <span className="slider round" />
      </label>
      {props.checked === 'OR' && (
        <span onClick={onSwitch} className="bool-selected--off">
          OR
        </span>
      )}
      {props.checked === 'AND' && (
        <span onClick={onSwitch} className="bool-selected--on">
          AND
        </span>
      )}
    </div>
  );
};

SwitchButton.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  labelRight: PropTypes.string,
  disabled: PropTypes.bool,
  checked: PropTypes.string,
  onChange: PropTypes.func
};

SwitchButton.defaultProps = {
  id: '',
  name: 'switch-button',
  label: '1',
  labelRight: '2',
  disabled: false,
  checked: 'OR',
  onChange: () => {}
};

export default SwitchButton;
